import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { loadSetupStatus } from "../../services/appQueries";
import { AuthContext } from "./AuthContext";

export const FoundationSetupContext = createContext(null);

function isStaffRole(role) {
  const r = String(role || "").toLowerCase();
  return r === "admin" || r === "hr" || r === "superadmin" || r === "super_admin";
}

export default function FoundationSetupProvider({ children }) {
  const { role } = useContext(AuthContext);
  const [status, setStatus] = useState({
    loading: true,
    complete: false,
    departmentsCount: 0,
    designationsCount: 0,
    locationsCount: 0,
  });

  const load = useCallback(async (fresh) => {
    if (!isStaffRole(role)) {
      setStatus((s) => ({ ...s, loading: false, complete: true }));
      return;
    }
    setStatus((s) => ({ ...s, loading: true }));
    try {
      const data = (await loadSetupStatus({ fresh })) || {};
      const departmentsCount = Number(data.departments_count) || 0;
      const designationsCount = Number(data.designations_count) || 0;
      const locationsCount = Number(data.locations_count) || 0;
      const complete = Boolean(
        data.foundation_complete ??
          (departmentsCount > 0 && designationsCount > 0 && locationsCount > 0)
      );
      setStatus({
        loading: false,
        complete,
        departmentsCount,
        designationsCount,
        locationsCount,
      });
    } catch {
      setStatus((s) => ({ ...s, loading: false, complete: false }));
    }
  }, [role]);

  const refetch = useCallback(() => load(true), [load]);

  useEffect(() => {
    load(false);
  }, [load]);

  return (
    <FoundationSetupContext.Provider value={{ status, refetch }}>
      {children}
    </FoundationSetupContext.Provider>
  );
}

export function useFoundationSetup() {
  return useContext(FoundationSetupContext);
}
